//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      showSettings: false,
      cameraRotation: 0,
      cameraZoom: 1,
      cameraFullscreen: false,
    };
  },
  watch: {
    cameraRotation(value) {
      this.$emit("changeRotation", value);
    },
    cameraZoom(value) {
      this.$emit("changeZoom", value);
    },
    cameraFullscreen(value) {
      this.$emit("changeFullscreen", value);
    },
  },
  computed: {
    leadActive() {
      return {
        "text-man-100": this.showRole === "Lead",
      };
    },
    followActive() {
      return {
        "text-lady-100": this.showRole === "Follow",
      };
    },
    bothActive() {
      return {
        "text-indigo-500": this.showRole === "Both",
      };
    },
    cameraRotationLOD() {
      return this.degreesToFacing(this.cameraRotation);
    },
  },
  methods: {
    rotate(deg) {
      this.cameraRotation += deg;
    },
    changeZoom(increment) {
      this.cameraZoom += increment;
    },
    degreesToFacing(deg) {
      if (deg >= 0) {
        switch (deg % 360) {
          case 0:
            return "LOD";
          case 315:
            return "DW";
          case 270:
            return "W";
          case 225:
            return "BDW";
          case 180:
            return "BLOD";
          case 135:
            return "BDC";
          case 90:
            return "C";
          case 45:
            return "DC";
        }
      } else {
        switch (Math.abs(deg % 360)) {
          case 0:
            return "LOD";
          case 315:
            return "DC";
          case 270:
            return "C";
          case 225:
            return "BDC";
          case 180:
            return "BLOD";
          case 135:
            return "BDW";
          case 90:
            return "W";
          case 45:
            return "DW";
        }
      }
      return deg % 360;
    },
  },
};
